<template>
  <div>
    <el-dialog
      custom-class="create-work-dialog"
      title="创建工单"
      width="720px"
      :visible.sync="dialogVisible"
      append-to-body
      @close="$emit('update:visible', false)"
    >
      <div class="dialog-content-scroll">
        <el-form
          ref="workForm"
          :model="workForm"
          :rules="rules"
          label-width="100px"
          size="small"
          class="create-work-form"
        >
          <section class="form-section">
            <div class="form-section__head">
              <i class="el-icon-s-order form-section__icon"></i>
              <h3 class="form-section__title">工单信息</h3>
            </div>
            <div class="form-section__body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="来源" prop="orderType">
                    <el-select
                      v-model="workForm.orderType"
                      placeholder="请选择来源"
                      clearable
                      style="width: 100%"
                    >
                      <el-option label="线上" :value="0" />
                      <el-option label="门店" :value="1" />
                      <el-option label="商城" :value="2" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工单类型" prop="workType">
                    <el-select
                      v-model="workForm.workType"
                      placeholder="请选择"
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in workOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="订单编号" prop="orderSn">
                    <el-input
                      v-model="workForm.orderSn"
                      placeholder="请输入订单编号"
                      @change="orderSnBlur"
                      @input="handleInput"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="水洗码" prop="washingCode">
                    <el-input
                      v-model="workForm.washingCode"
                      placeholder="多个请用英文逗号隔开"
                      @change="washCodeBlur"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </section>

          <section class="form-section">
            <div class="form-section__head">
              <i class="el-icon-user form-section__icon form-section__icon--user"></i>
              <h3 class="form-section__title">用户与处理</h3>
            </div>
            <div class="form-section__body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="处理人员" prop="handleMan">
                    <el-select
                      v-model="workForm.handleMan"
                      placeholder="请选择"
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in manOptions"
                        :key="item.id"
                        :label="item.nickname || item.username"
                        :value="item.nickname || item.username"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="用户名" prop="memberUsername">
                    <el-input v-model="workForm.memberUsername" disabled placeholder="填写订单编号后自动带入" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="用户号码">
                    <el-input v-model="workForm.phone" disabled placeholder="填写订单编号后自动带入" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </section>

          <section class="form-section form-section--last">
            <div class="form-section__head">
              <i class="el-icon-setting form-section__icon form-section__icon--setting"></i>
              <h3 class="form-section__title">处理设置</h3>
            </div>
            <div class="form-section__body">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="优先级" prop="priority" class="radio-item">
                    <el-radio-group v-model="workForm.priority">
                      <el-radio :label="1">普通</el-radio>
                      <el-radio :label="2">紧急</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="状态" prop="status" class="radio-item">
                    <el-radio-group v-model="workForm.status">
                      <el-radio :label="0">待处理</el-radio>
                      <el-radio :label="2">已完成</el-radio>
                      <el-radio :label="3">已拒绝</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="备注" prop="handleNote">
                <el-input
                  v-model="workForm.handleNote"
                  type="textarea"
                  :rows="4"
                  placeholder="选填"
                />
              </el-form-item>
            </div>
          </section>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="handleWorkDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCookie } from "@/unit/cookie";
import { getUser } from "@/api/power.js";
import { insertOrderWork, getOrderSn } from "@/api/order.js";
import { getOrderSnOffline } from "@/api/store.js";
import { getOrderSnSmall } from "@/api/mall.js";
import { orderItemByWashingCode } from "@/api/product.js";

const defaultWork = {
  memberUsername: "",
  orderId: null,
  orderSn: "",
  washingCode: "",
  handleMan: getCookie("nickname") || getCookie("username"),
  promoterMan: getCookie("nickname") || getCookie("username"),
  workType: null,
  priority: 1,
  status: 0,
  handleNote: "",
  factoryId: null,
  phone: "",
  orderType: null,
};

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    myObject: {
      type: Object,
      default: () => ({}),
    },
    isWork: {
      type: Number,
      default: 0,
    },
    smallText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      workForm: Object.assign({}, defaultWork),
      dialogVisible: this.visible,
      workData: {},
      manOptions: [],
      rules: {
        orderSn: [
          { required: true, message: "订单编号不能为空", trigger: "blur" },
        ],
        workType: [
          { required: true, message: "请选择工单类型", trigger: "blur" },
        ],
        orderType: [
          { required: true, message: "请选择工单来源", trigger: "blur" },
        ],
      },
      workOptions: [
        { value: 1, label: "订单异常" },
        { value: 2, label: "售后" },
        { value: 3, label: "漏补发" },
        { value: 4, label: "催单" },
        { value: 5, label: "投诉" },
        { value: 6, label: "个人业务" },
        { value: 7, label: "疑似丢件" },
        { value: 8, label: "退款" },
        { value: 9, label: "数量不符" },
        { value: 10, label: "补款" },
        { value: 11, label: "退洗" },
      ],
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      if (newValue) {
        this.getUser();
      }
      this.workForm = Object.assign({}, defaultWork);
      this.workData = this.myObject;
      this.workForm.memberUsername = this.myObject
        ? this.myObject.senderName
        : "";
      this.workForm.orderSn = this.myObject ? this.myObject.orderSn : "";
      this.workForm.phone = this.myObject ? this.myObject.phone : "";
      this.workForm.orderId = this.myObject ? this.myObject.id : null;
      if (this.isWork == 1) {
        this.workForm.workType = 9;
        this.workForm.orderType = 0;
      } else if (this.isWork == 2) {
        this.workForm.workType = 8;
        this.workForm.orderType = 1;
        this.workForm.washingCode = this.myObject
          ? this.myObject.washingCode
          : "";
      } else if (this.isWork == 3) {
        this.workForm.workType = 8;
        this.workForm.orderType = 2;
        this.workForm.handleNote = this.smallText;
      } else {
        this.workForm.workType = null;
        this.workForm.orderType = null;
      }
      this.workForm.factoryId = this.myObject ? this.myObject.factoryId : null;
    },
  },
  methods: {
    async handleWorkDialogConfirm() {
      const valid = await new Promise((resolve) => {
        this.$refs.workForm.validate((ok) => resolve(ok));
      });
      if (!valid) {
        return this.$message.error("请填写必要的表单项！");
      }
      try {
        const res = await insertOrderWork(this.workForm);
        if (res.data && res.data.code === 200) {
          this.$message.success("创建成功！");
          this.dialogVisible = false;
          if (this.isWork == 0) {
            this.$emit("refreshList");
          } else {
            this.$emit("refreshWork", true);
          }
        } else {
          this.$message.error(
            (res.data && res.data.message) || "创建工单失败",
          );
        }
      } catch (err) {
        console.error(err);
        this.$message.error("创建工单失败，请稍后重试");
      }
    },
    handleCancel() {
      this.dialogVisible = false;
      this.workData = {};
      this.$refs.workForm.clearValidate();
    },
    async getUser() {
      const { data: res } = await getUser();
      if (res.code === 200) {
        this.manOptions = res.data;
      }
    },
    washCodeBlur(value) {
      let str = value.split(",")[0];
      if (this.isWork) {
        this.orderItemByWashingCode(str);
      }
    },
    orderSnBlur(value) {
      if (!this.isWork) {
        this.getOrderSn(value);
      }
    },
    handleInput(value) {
      this.workForm.orderSn = value.replace(/\s+/g, "");
    },
    async orderItemByWashingCode(washingCode) {
      const { data: res } = await orderItemByWashingCode(washingCode);
      if (res.code === 200 && res.data) {
        this.getOrderSn(res.data.orderSn);
      }
    },
    isMD(str) {
      return str.substr(0, 2) === "MD";
    },
    isSP(str) {
      return str.substr(0, 2) === "SP";
    },
    getOrderSn(orderSn) {
      if (this.workForm.orderType == 1 || this.isMD(orderSn)) {
        this.offline(orderSn);
      } else if (this.workForm.orderType == 2 || this.isSP(orderSn)) {
        this.smallOrder(orderSn);
      } else {
        this.online(orderSn);
      }
    },
    async online(orderSn) {
      const { data: response } = await getOrderSn(orderSn);
      if (response.code === 200 && response.data) {
        this.workData = response.data;
        this.workForm.orderId = response.data.id;
        this.workForm.orderSn = response.data.orderSn;
        this.workForm.memberUsername = response.data.senderName;
        this.workForm.phone = response.data.phone;
        this.workForm.factoryId = response.data.factoryId;
      }
    },
    async offline(orderSn) {
      const { data: response } = await getOrderSnOffline(orderSn);
      if (response.code === 200 && response.data) {
        this.workData = response.data;
        this.workForm.orderId = response.data.id;
        this.workForm.orderSn = response.data.orderSn;
        this.workForm.memberUsername = response.data.senderName;
        this.workForm.phone = response.data.phone;
        this.workForm.factoryId = response.data.factoryId;
        this.workForm.washingCode = response.data.washingCode;
      }
    },
    async smallOrder(orderSn) {
      const { data: response } = await getOrderSnSmall(orderSn);
      if (response.code === 200 && response.data) {
        this.workData = response.data;
        this.workForm.orderId = response.data.id;
        this.workForm.orderSn = response.data.orderSn;
        this.workForm.memberUsername = response.data.senderName;
        this.workForm.phone = response.data.phone;
      }
    },
  },
};
</script>

<style scoped lang="less">
.create-work-form {
  .el-form-item {
    margin-bottom: 16px;
  }

  .el-select,
  .el-input {
    width: 100%;
  }
}

.form-section {
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  overflow: hidden;

  &--last {
    margin-bottom: 0;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fafbfc;
    border-bottom: 1px solid #f0f2f5;
  }

  &__icon {
    font-size: 16px;
    color: #409eff;

    &--user {
      color: #67c23a;
    }

    &--setting {
      color: #e6a23c;
    }
  }

  &__title {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  &__body {
    padding: 16px 16px 4px;
  }
}

.radio-item {
  /deep/ .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
}
</style>

<style lang="less">
.create-work-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  margin-top: 5vh !important;
  margin-bottom: 5vh;
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    flex-shrink: 0;
    padding: 16px 24px 12px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    padding: 0 !important;
    overflow: hidden;
    background: #f5f7fa;
  }

  .el-dialog__footer {
    flex-shrink: 0;
    padding: 12px 24px 16px;
    border-top: 1px solid #ebeef5;
    background: #fff;
  }

  .dialog-content-scroll {
    max-height: calc(90vh - 118px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 16px 20px 12px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dcdfe6;
      border-radius: 3px;
    }
  }
}
</style>
